<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">化学品采购申请</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择审批状态">
            <el-option v-for="item in $store.state.reviewStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增申请</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训化学品采购申请模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <!-- <custom-table-column fixed prop="type" label="采购类别" min-width="150">
        </custom-table-column> -->
        <custom-table-column prop="status_text" label="状态" width="80">
        </custom-table-column>
        <custom-table-column prop="apply_structure_1" label="所属院系" width="180">
        </custom-table-column>
        <custom-table-column prop="apply_structure_2" label="专业" width="180">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="180">
        </custom-table-column>
        <custom-table-column prop="grade" label="年级" width="160">
        </custom-table-column>
        <custom-table-column prop="apply_reason" label="申请理由" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="review_name" label="审批人" width="100px">
        </custom-table-column>
        <custom-table-column prop="review_desc" label="说明原因" width="160px">
        </custom-table-column>
        <custom-table-column prop="review_time" label="审批时间" width="160px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="detailMethod(scope.row, 'view')" type="text" size="small">详情</el-button>
            <el-button @click="detailMethod(scope.row, 'edit')" v-if="scope.row.status == 1" type="text"
              size="small">编辑</el-button>
            <el-button v-if="scope.row.status != 2" @click="handleDelet(scope.row.id)" type="text"
              size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
      </OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="组织结构" prop="apply_structure_1">
          <el-input v-model="selectName" placeholder="请选择" style="width:552px;" @focus="dialogOpen"
            @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item label="学年学期" prop="term">
          <el-select v-model="ruleForm.term" clearable placeholder="请选择学年学期" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年  级" prop="grade">
          <el-select v-model="ruleForm.grade" style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.grades" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="总采购金额" prop="total_amount">
          <el-input v-model="ruleForm.total_amount" :disabled="true" placeholder="请输入" style="width:198px;"></el-input>
          元
        </el-form-item>
        <el-form-item label="申请理由" prop="apply_reason">
          <el-input type="textarea" v-model="ruleForm.apply_reason" placeholder="请输入" style="width:552px;" :rows="4">
          </el-input>
        </el-form-item>
        <div class="add_win">
          <p class="add_win_title">采购清单</p>
          <div v-for="(item, index) in ruleForm.items" :key="index" class="add_win_body el-form">
            <el-form-item label="化学品名称" :prop="`items[${index}].name`">
              <el-input v-model="item.name" placeholder="请输入名称" style="width:216px;"></el-input>
            </el-form-item>
            <el-form-item label="化学品数量" :prop="`items[${index}].quantity`">
              <el-input v-model="item.quantity" placeholder="请输入" @input="handleInput(item)"
                style="width:196px;"></el-input>
            </el-form-item>
            <el-form-item label="单位" :prop="`items[${index}].unit`">
              <el-select v-model="item.unit" clearable placeholder="请选择" style="width:216px;">
                <el-option v-for="(item, index) in $store.state.chemicalUnit" :key="index" :label="item"
                  :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单价" :prop="`items[${index}].price`">
              <el-input v-model="item.price" @input="handleInput(item)" placeholder="请输入"
                style="width:196px;"></el-input>
            </el-form-item>
            <el-form-item label="总金额" :prop="`items[${index}].total_price`">
              <el-input v-model="item.total_price" disabled placeholder="请输入" style="width:196px;"></el-input> 元
            </el-form-item>
            <div class="add_win_del">
              <el-button type="danger" @click="handleItemDelete(item, index)" size="mini">删除</el-button>
            </div>
          </div>
          <div class="add_win_add">
            <el-button size="mini" @click="handleItemAdd()">新增一条+</el-button>
          </div>
        </div>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="采购详情" :visible.sync="detailDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="申请单" direction="vertical" :column="3" border v-if="rowObj">
        <!-- <el-descriptions-item>
          <template slot="label">采购类别 </template> {{ rowObj.type }}
        </el-descriptions-item> -->
        <el-descriptions-item>
          <template slot="label">审批状态 </template> {{ rowObj.status_text }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">说明原因 </template> {{ rowObj.review_desc }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">审批时间 </template> {{ rowObj.review_time }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">学年学期 </template> {{ rowObj.term }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">年 级 </template> {{ rowObj.grade }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">总采购金额 </template> {{ rowObj.total_amount }}元
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">所属院系 </template> {{ rowObj.apply_structure_1 }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">专业 </template> {{ rowObj.apply_structure_2 }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请理由 </template> {{ rowObj.apply_reason }}
        </el-descriptions-item>
      </el-descriptions>
      <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px;">采购清单</p>
      <el-descriptions class="margin-top" title="" style="margin-bottom:16px;" v-for="(item, index) in rowObj.items"
        :key="index" direction="vertical" :column="5" :size="size" border>
        <el-descriptions-item>
          <template slot="label">化学品名称</template> {{ item.name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">化学品数量 </template> {{ item.quantity }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">单 位</template> {{ item.unit }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">单 价 </template> {{ item.price }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">总 价 </template> {{ item.total_price }}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport, mixinValidate, mixinFormatter],
  data() {
    return {
      formInline: {
        structure_1: '',
        major: '',
        status: '',
      },
      size: 'small',
      detailDialogVisible: false,
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      ruleForm: {
        "apply_structure_1": "",
        "apply_structure_2": "",
        "term": "",
        "grade": "",
        "total_amount": 0,
        "apply_reason": "",
        "items": [{ "name": "", "quantity": '', "unit": "", "price": '', "total_price": 0 }]
      },
      rowObj: {},
      plist: [],
      classRooms: [],
      rules: {
      },
      rulesRoot: {
        grade: [{ required: true, message: '请选择', trigger: 'change' }],
        apply_structure_1: [{ required: true, message: '请选择' }],
        term: [{ required: true, message: '请选择', trigger: 'change' }],
        total_amount: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
        apply_reason: [{ required: true, message: '请输入', trigger: 'blur' }],
        // training_room: [{ required: true, message: `请输入所属${this.$store.state.themeTitle}室`, trigger: 'change' }],
      },
      action: '',
      downloadUrl: '',
      downloadName: '实训化学品采购申请模版.xlsx',
      btnTitle: '导入实训化学品采购申请数据',
      listArr: [],
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/device/purchase2/import`;
    this.downloadUrl = `api/device/purchase2/getTemplate`;
    this.$store.dispatch('getTermms');
    this.setRules()
  },
  computed: {
  },
  mounted() { },
  methods: {
    generateArrRules() {
      const arrRules = {};
      this.ruleForm.items.forEach((item, index) => {
        arrRules[`items[${index}].name`] = [
          { required: true, message: `请输入`, trigger: 'blur' }
        ];
        arrRules[`items[${index}].quantity`] = [
          { required: true, message: `请输入`, trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' }
        ];
        arrRules[`items[${index}].unit`] = [
          { required: true, message: `请选择`, trigger: 'change' }
        ];
        arrRules[`items[${index}].price`] = [
          { required: true, message: `请输入`, trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' }
        ];
      });
      return arrRules;
    },

    handleItemDelete(item, index) {
      this.ruleForm.items.splice(index, 1);
    },
    handleInput(item) {
      item.total_price = (item.price ? item.price : 0) * (item.quantity ? item.quantity : 0);
      if (this.ruleForm.items && this.ruleForm.items.length) {
        this.ruleForm.total_amount = this.ruleForm.items.reduce((total, item) => {
          return total + item.total_price;
        }, 0);
      }
      // return  item.zj
    },
    handleAdd() {
      this.type = 'add';
      this.title = '新增';
      if (this.selectName) {
        this.selectName = '';
      }
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep);
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate();
        }
      });
    },
    handleApply(id, status) {
      let str = '通过';
      if (status == 2) {
        str = '拒绝';
      }
      this.confirmBox('warning', `此操作将${str}该采购申请，是否继续`, { id, status }, this.setStatus);
    },
    async setStatus(params) {
      let res = await this.$api.update.operDevicePurchase(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '处理成功！',
        });
        this.getList();
      }
    },
    // async detailMethod(row, type = "view") {
    //   let res = await this.$api.instance.interfaceServer(`api/chemical/purchase/detail/${row.id}`, 'get');
    //   if (res.code == 0 && res.data) {
    //     if (type == "view") {
    //       this.rowObj = res.data;
    //       this.detailDialogVisible = true;
    //     } else {
    //       this.handleEditNew(res.data)
    //     }
    //   }
    // },
    detailMethod(row, type = "view") {
      if (type == "view") {
        this.rowObj = row;
        this.detailDialogVisible = true;
      } else {
        this.handleEditNew(row)
      }
    },
    handleEditNew(row) {
      this.type = 'edit'
      this.title = "编辑"
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
      this.ruleForm = this.assignFormObj(this.ruleForm, row, ['id'])
      this.handleEditCallBackSetStruc({ major: 'apply_structure_2', dep: 'apply_structure_1', row: row })
      this.centerDialogVisible = true;
    },
    setRules() {
      this.rules = {
        ...this.rulesRoot,
        ...this.generateArrRules()
      };
    },
    handleItemAdd() {
      this.ruleForm.items.push({ "name": "", "quantity": '', "unit": "", "price": '', "total_price": 0 });
      this.setRules();

    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/chemical/purchase/delete/${params.id}`, 'DELETE', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/chemical/purchase/create', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/chemical/purchase/update/${params.id}`, 'put', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.beforeGetOrgan({ limit: false, major: "apply_structure_2", dep: 'apply_structure_1' });
    },
    handleQuery() {
      this.beforeQueryByKeyNew({ major: "apply_structure_2", dep: 'apply_structure_1' });
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/chemical/purchase/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
